<template>
  <div class="global-func-container">
    <div class="event-properties-item">
      <div class="event-label">函数名</div>
      <div>
        <!-- <el-input
          size="mini"
          placeholder="全局函数名"
          v-model="event.value"
        ></el-input> -->
        <el-autocomplete
          class="inline-input"
          v-model="event.value"
          :fetch-suggestions="querySearch"
          @select="select($event, event)"
          size="mini"
        >
          <div slot-scope="{ item }">{{ item }}</div>
        </el-autocomplete>
      </div>
    </div>

    <div class="event-properties-item">
      <div class="event-label">参数</div>
      <div>
        <el-input
          size="mini"
          placeholder="传入参数(可选)"
          v-model="event.params"
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["uuid", "technology"],
  data() {
    return {
      url: "",
      target: "_blank",
      event: {},
      globalFunctions: {},
    };
  },
  created() {
    this.event = this.technology.getEvent(this.uuid);
    this.globalFunctions = this.technology.globalFunctions;
    console.log(this.globalFunctions);
  },
  methods: {
    select(e, item) {
      item.value = e;
    },
    querySearch(queryString, cb) {
      var restaurants = this.globalFunctions;
      console.log(restaurants)
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .event-label {
    width: 120px;
  }
}
</style>